import React from 'react';
import ContactForm from '../ContactFrom/ContactForm'


const Contactpage = () => {

    return (
      <section className="wpo-contact-pg-section section-padding">
        <div className="container">
          <div className="row">
            <div className="col col-lg-10 offset-lg-1">
              <div className="office-info">
                <div className="row">
                  <div className="col col-xl-4 col-lg-6 col-md-6 col-12">
                    <div className="office-info-item">
                      <div className="office-info-icon">
                        <div className="icon">
                          <i className="fi flaticon-location-1"></i>
                        </div>
                      </div>
                      <div className="office-info-text">
                        <h2>Dirección</h2>
                        <p>Urbanización Av. Panteón, Caracas, Venezuela</p>
                      </div>
                    </div>
                  </div>
                  <div className="col col-xl-4 col-lg-6 col-md-6 col-12">
                    <div className="office-info-item">
                      <div className="office-info-icon">
                        <div className="icon">
                          <i className="fi flaticon-location-1"></i>
                        </div>
                      </div>
                      <div className="office-info-text">
                        <h2>Dirección</h2>
                        <p>Urbanización Av. Panteón, Caracas, Venezuela</p>
                      </div>
                    </div>
                  </div>
                  <div className="col col-xl-4 col-lg-6 col-md-6 col-12">
                    <div className="office-info-item">
                      <div className="office-info-icon">
                        <div className="icon">
                          <i className="fi flaticon-email"></i>
                        </div>
                      </div>
                      <div className="office-info-text">
                        <h2>Email</h2>
                        <p>wmclinicplus@gmail.com</p>
                      </div>
                    </div>
                  </div>
                  <div className="col col-xl-4 col-lg-6 col-md-6 col-12">
                    <div className="office-info-item">
                      <div className="office-info-icon">
                        <div className="icon">
                          <i className="fi flaticon-phone-call"></i>
                        </div>
                      </div>
                      <div className="office-info-text">
                        <h2>Teléfono</h2>
                        <p>+58 414-2933760</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="wpo-contact-title">
                <h2>¿Tienes alguna pregunta?</h2>
                <p>
                  Si tienes alguna pregunta o inquietud, no dudes en
                  contactarnos. Estamos aquí para ayudarte y responder a todas
                  tus dudas.
                </p>
              </div>
              <div className="wpo-contact-form-area">
                <ContactForm />
              </div>
            </div>
          </div>
        </div>
        <section className="wpo-contact-map-section">
          <div className="wpo-contact-map">
            <iframe
              title="comtact-map"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3922.874890956013!2d-66.8992556!3d10.510518999999999!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8c2a59529815d00b%3A0x1b87d5d34c407476!2sWMCLINIC!5e0!3m2!1ses-419!2sco!4v1750863066711!5m2!1ses-419!2sco"
            ></iframe>
          </div>
        </section>
      </section>
    );

}

export default Contactpage;
